import { render, staticRenderFns } from "./EditaFlagRetirado.vue?vue&type=template&id=b54bc04e"
import script from "./EditaFlagRetirado.vue?vue&type=script&lang=js"
export * from "./EditaFlagRetirado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports